import React from 'react'
import PropTypes from 'prop-types'
import { debounce, flowRight } from 'lodash'

import Styles from './index.scss'

const ActionsMerge = props => (
  <div className={Styles.containerActions}>
    <span className={Styles.titleActions}>
      {props.typeMerge === 'newData' ? 'Create New Data' : 'Search for Existing'}
    </span>
    {props.typeMerge === 'newData' ? (
      <input
        type="text"
        className={Styles.inputNew}
        value={props.inputMergeName}
        onChange={props.setInputMergeName}
      />) : (
        <div>
          <input
            type="text"
            className={Styles.searchInput}
            placeholder="Search..."
            onChange={flowRight(debounce(props.searchDataToMerge, 300), e => e.persist() || e)}
          />
          <select
            size={5}
            className={Styles.dropdownSelection}
            onChange={props.setExistingDataSelected}
          >
            {props.dataSelection.rows.map(data => (
              <option
                key={data.id}
                className={Styles.dropdownItem}
                value={data.id}
              >
                {data.name}
              </option>
            ))}
          </select>
        </div>
      )}
    <div className={Styles.containerBtnActions}>
      <button className={Styles.btnCancel} onClick={props.onCancel}>Back</button>
      <button
        className={`${Styles.btnConfirm} ${props.inputMergeName === '' ? Styles.btnDisabled : ''}`}
        onClick={props.setOpenModalMerge(true, 'merge')}
        disabled={props.inputMergeName === ''}
      >
        Create
      </button>
    </div>
  </div>
)

ActionsMerge.defaultProps = {
  dataSelection: {
    rows: [],
  },
}

ActionsMerge.propTypes = {
  onCancel: PropTypes.func.isRequired,
  setInputMergeName: PropTypes.func.isRequired,
  inputMergeName: PropTypes.string.isRequired,
  setOpenModalMerge: PropTypes.func.isRequired,
  typeMerge: PropTypes.string.isRequired,
  dataSelection: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  setExistingDataSelected: PropTypes.func.isRequired,
  searchDataToMerge: PropTypes.func.isRequired,
}

export default ActionsMerge
